<template>
    <div 
        class="number-round rounded-circle text-white d-inline-block text-center" 
        :class="variant ? 'bg-' + variant : ''"
        :style="{
            minWidth: size, 
            height: size,
            fontSize: fontSize,
            }"
    >
        <div class="w-100 h-100 d-flex align-items-center justify-content-center">
            <span v-if="text" key="showText">{{ text.toString() }}</span>
            <b-icon v-else-if="icon" key="showIcon" :icon="icon" class="text-white"></b-icon>
        </div>
    </div>
</template>

<script>

export default {
    name: 'NumberRound',
    components: {},
    props: {
        size: {  // size string, like '32px' or '2rem' -- will be same for height/width
            type: String,
            default: '32px',
        },
        fontSize: {
            type: String,
            default: '1rem',
        },
        text: {
            type: [Number, String],
            default: '',
        },
        icon: {
            type: String,
            default: '',  // text has first priority, but if text is '' and has icon, then it will show icon
        },
        variant: {  // BS color variant for BACKGROUND color
            type: String,
            required: false,
        },
    },
}
</script>

<style>

</style>